export const LOT_FILTER_VALUES = {
    VL: 'VL',
    HL: 'HL',
    NL: 'NL'
};